// @flow

import styled from 'styled-components';
import { colors, fontWeight } from '../constants';

const SectionHeader = styled.h2`
  font-family: Untitled Sans, sans-serif;
  font-size: 18px;
  line-height: 26px;
  color: ${colors.darkestGrey};
  ${fontWeight('normal')}
`;

export default SectionHeader;
